import axios from 'axios'
import { config } from '../config'
import store from '../reducer/store'
import { setUsers } from '../reducer/slices/User'

function goToError (data, navigate) {
  const object = {
    error: true,
    message: data.message,
    code: data.code,
    status: data.status,
    data: data.response.data
  }

  navigate('/', { state: object })
}

// AUTENTICACION
function getCredetentials () {
  const { user } = store.getState()
  const auth = {
    headers: {
      Authorization: JSON.stringify({
        token: user.token,
        userId: user.userId,
        roles: user.roles
      })
      // ,
      // 'Content-Type': 'application/json'
    }
  }

  return auth
}

export const getDocumnent = async (url, navigate) => {
  let response
  let resError

  const petition = await axios
    .get(
      url,
      getCredetentials()
    )
    .catch((response) => {
      goToError(response, navigate)

      resError = {
        error: true,
        message: response.message,
        code: response.response.status
      }
    })

  if (!resError) response = { data: petition?.data, status: petition?.status }

  return resError !== undefined ? resError : response
}
// GET
export const getData = async (ruta, id, navigate) => {
  let response
  let petition
  let resError
  const credentials = ruta === 'reports' ? null : getCredetentials()

  if (id !== undefined) {
    petition = await axios
      .get(
        `${config.backend.host}:${config.backend.portHttp}/${ruta}/${id}`,
        credentials
      )
      .catch((response) => {
        goToError(response, navigate)

        resError = {
          error: true,
          message: response.message,
          code: response.response.status
        }
      })
  } else {
    petition = await axios
      .get(
        `${config.backend.host}:${config.backend.portHttp}/${ruta}`,
        credentials
      )
      .catch((response) => {
        goToError(response, navigate)

        resError = {
          error: true,
          message: response.message,
          code: response.response.status
        }
      })
  }

  if (!resError) response = { data: petition?.data, status: petition?.status }

  return resError !== undefined ? resError : response
}

// POST
export const postData = async (table, payload, navigate) => {
  let response
  let resError
  let data

  if (table === 'actions') {
    data = {
      actions: payload
    }
  } else {
    data = payload
  }

  const petition = await axios
    .post(
      `${config.backend.host}:${config.backend.portHttp}/${table}`,
      data,
      getCredetentials()
    )
    .catch((response) => {
      goToError(response, navigate)

      resError = {
        error: true,
        message: response.message,
        code: response.response.status
      }

      if (table === 'users' || table === 'rxartsecure/license_activation') {
        resError.data = response.response.data
      }
    })

  if (!resError) response = { data: petition.data, status: petition.status }

  return resError !== undefined ? resError : response
}

// PUT
export const putData = async (table, payload, navigate) => {
  let response
  let resError

  const petition = await axios
    .put(
      `${config.backend.host}:${config.backend.portHttp}/${table}`,
      payload,
      getCredetentials()
    )
    .catch(({ response }) => {
      goToError(response, navigate)

      resError = {
        error: true,
        message: response.message,
        code: response.response.status
      }
    })

  if (!resError) response = { data: petition.data, status: petition.status }

  return resError !== undefined ? resError : response
}

// DELETE
export const deleteData = async (table, id, navigate) => {
  let response
  let resError

  const petition = await axios
    .delete(
      `${config.backend.host}:${config.backend.portHttp}/${table}/${id}`,
      getCredetentials()
    )
    .catch(({ response }) => {
      goToError(response, navigate)

      resError = {
        error: true,
        message: response.message,
        code: response.response.status
      }
    })

  if (!resError) response = { data: petition.data, status: petition.status }

  return resError !== undefined ? resError : response
}

// ------------------ LOGIN ------------------

export const verifyUser = async (payload, navigate, language) => {
  // console.log(`${config.backend.host}:${config.backend.portHttp}/login`)

  let resError
  const data = await axios
    .put(`${config.backend.host}:${config.backend.portHttp}/login`, payload)
    .catch((response) => {
      goToError(response, navigate)

      resError = {
        error: true,
        message: response.message,
        code: response.response.status
      }
    })

  if (data !== undefined) {
    if (data?.data.auth) {
      const role = data.data.roles ? data.data.roles : language === 'es' ? config.usersWithoutRoleEs : language === 'en' ? config.usersWithoutRoleEn : null
      const sesion = {
        userId: data.data.id,
        range: data.data.range,
        token: data.data.token,
        roles: role
      }
      sessionStorage.setItem('userId', sesion.userId)
      sessionStorage.setItem('range', sesion.range)
      sessionStorage.setItem('token', sesion.token)
      sessionStorage.setItem('roles', JSON.stringify(role))

      store.dispatch(setUsers(sesion))
    }
  }

  return resError !== undefined ? resError : data
}
